import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import Select, { components } from "react-select";
import { Icon, Input, Button, Dropdown, Grid, Card, Popup, Segment, Tab, Table, Menu, Form, TextArea, Label, Header, Checkbox } from 'semantic-ui-react';
import { getkpidata, getkpidata1, getAgingDashboard,Fetchexecutequery, getkpidata3, getexceptiondata, getkpidata4, getexceptiondata1, getProcessingLayerListFromServer, getdashboard1sidement } from '../../../services/demo/brs/brsService1';
import axios from "axios";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'semantic-ui-css/semantic.min.css';
import Modal from 'react-bootstrap/Modal';
import * as XLSX from 'xlsx';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../txbrs/dashboard_new.css';
import Accordion from 'react-bootstrap/Accordion';
import DualBarGraph from '../txbrs/dual_bar_graph';
import BarGraph from '../txbrs/bar_graph';
import SearchInput from '../txbrs/search_input';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboard,faFileExcel } from '@fortawesome/free-solid-svg-icons';


const DashboardComponent = () => {
  const [input1, setInput1] = useState('');
  const [input2, setInput2] = useState('');
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [seriesdonut, setseriesdonut] = useState();
  const [serieslabels, setserieslabels] = useState([]);
  const [seriesdata, setseriesdata] = useState([]);
  const [extGridData, setExtGridData] = useState([]);
  const [modelcolumnnames, setmodelcolumnnames] = useState([]);
const [annexure1Data, setAnnexure1Data] = useState([]);
const [annexure2Data, setAnnexure2Data] = useState([]);
const [annexure3Data, setAnnexure3Data] = useState([]);
const [annexure4Data, setAnnexure4Data] = useState([]);

  const [imagePath, setImagePath] = useState('../../../assets/images/icici.png');
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1; // getMonth() returns 0-based month, so add 1
  const currentYear = currentDate.getFullYear();
  // Format the selectedDate in 'YYYY-MM' format
  const formattedDate = `${currentYear}-${String(currentMonth).padStart(2, '0')}`;
  const [selectedDate, setSelectedDate] = useState(formattedDate);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [serieslabels1, setserieslabels1] = useState([]);
  const [seriesdata1, setseriesdata1] = useState([]);
  const [bankOptions, setbankOptions] = useState([]);
  const [selectedBank, setSelectedBank] = useState([]);
  const [entityOptions, setEntityOptions] = useState([]);
  const [filteredEntityOptions, setFilteredEntityOptions] = useState([]);
  const [filteredBankOptions, setFilteredbankOptions] = useState([]);
  const [selectedEntity, setSelectedEntity] = useState([]);
  const [bankEntityMapping, setBankEntityMapping] = useState([]); // To store the relationship
  const [entityBankMapping, setEntityBankMapping] = useState([]);

  const [kpidata2, setkpidata2] = useState([]);

  const [show, setShow] = useState(false);

  const [options, setOptions] = useState([]);
  const [options1, setOptions1] = useState([]);
  const [filterText, setFilterText] = useState('');

  const [clientids, setclientids] = useState([]);
  const [bankquery , setBankquery] = useState('');
  const [erpquery , setERPquery] = useState('');
  const [differencequery, setDifferencequery] = useState('');

  const [userid, setuserid] = useState(userCredentials["user_id"]);

  const [doughnutLabel, setDoughnutLabel] = useState([]);
  const [doughnutdata, setDoughnutData] = useState([]);
  const [doughnutLabel1, setDoughnutLabel1] = useState([]);
  const [doughnutdata1, setDoughnutData1] = useState([]);
  const [doughnutLabel2, setDoughnutLabel2] = useState([]);
  const [doughnutdata2, setDoughnutData2] = useState([]);
  const [doughnutLabel3, setDoughnutLabel3] = useState([]);
  const [doughnutdata3, setDoughnutData3] = useState([]);
  const [doughnutLabel4, setDoughnutLabel4] = useState([]);
  const [doughnutdata4, setDoughnutData4] = useState([]);

  const [barwidth, setbarwidth] = useState('40%');
  const [radialseries, setradialseries] = useState([89.52]);
  const headers = ['0-30 Days','31-60 Days','61-90 Days','90+ Days']
  const [data1, seterpData1] = useState([]);
  const [data2, setbankData2] = useState([]);
  const [lastDate, setlastDate] = useState('');
  const [erpDifference, seterpDifference] = useState([]);
  const [bankDifference, setbankDifference] = useState([]);
  const [tanDifferenceheaders, setTanDifference] = useState([]);

  const [tandeductors, setTanDeductors] = useState([]);
  const [erptandeductors, seterpTanDeductors] = useState([]);

const getLastDateOfMonth = (year, month) => {
  // Create a date object for the first day of the next month, and subtract one day to get the last day of the current month
  const date = new Date(year, month, 0);  // month is 0-indexed, so 0 represents January, 1 represents February, etc.
  
  // Get the day and month abbreviation
  const day = String(date.getDate()).padStart(2, '0');
  const monthAbbr = date.toLocaleString('default', { month: 'short' }); // Get the month abbreviation (e.g., 'Aug')
  
  // Format the final date string as "DD-MMM-YYYY"
  const formattedDate = `${day}-${monthAbbr}-${year}`;
  
  console.log("formattedDate", formattedDate);
  return formattedDate;
};


  let sideinfo_list = [];

  const chartDatanew = {
    series: doughnutdata2,
    options: {
      labels: doughnutLabel2,
      colors: ['#7C9ED9', '#F13030', '#0A2352', '#b84dff', '#ff944d', '#00cccc', '#3E4C5E', '#4381C1', '#80A1C1', '#C7D3DD'],
      legend: {
        onItemClick: {
          toggleDataSeries: false,
        },

      },
      chart: {
        width: 280,
        height: 370,
        type: 'donut'
      },
      plotOptions: {
        pie: {
          startAngle: -90,
          endAngle: 270
        },
      },
      dataLabels: {
        enabled: false
      },
      fill: {
        type: 'gradient',
      },
      // legend: doughnutLabel,
      title: {
        text: ''
      },

      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
            height: 250,
          },
          legend: {
            position: 'bottom'
          }
        }
      }],

    },
  };
  useEffect(() => { 

  let lastDate1 = getLastDateOfMonth(selectedYear,selectedMonth);
  setlastDate(lastDate1);

 },[selectedMonth, selectedYear]);


  // Chart options
  const options123 = {
    chart: {
      id: 'line-chart',
      type: 'line',
      height: 350,
    },
    xaxis: {
      categories:  ['Jan', 'Feb', 'Mar'],
    },
    title: {
      text: 'Monthly Sales Data',
      align: 'center',
    },
    stroke: {
      curve: 'smooth', // smooth curve for the line
    },
    markers: {
      size: 4,
      hover: {
        size: 7,
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
    },
  };

  // Dynamic data series for the line chart
  const series = [
    {
      name: 'Sales',
      data: [30, 40, 50],
    },
  ];



  
  useEffect(() => {
    let bankquery = `
      SELECT 
    \`TAN of Deductor\`, \`Name of Deductor\`,
    \`Total TDS Deposited\` AS total_tds 
FROM 
    tx26.as_summary 
ORDER BY 
    total_tds DESC;`

  let erpquery =  `SELECT tan_no,\`party name\`,round(sum(NetAmt),2) as difference FROM tx26.gl where tan_no is not null group by tan_no,\`party name\` order by difference desc;`
     console.log("selectedBank",selectedBank )
let differencequery = `SELECT 
    sub.tan,sub.erp_total,sub.total_tds,
    round(ABS(sub.erp_total - sub.total_tds),2) AS difference
FROM (
    SELECT 
        f.\`TAN of Deductor\` AS tan,
        f.\`Name of Deductor\` AS customer_name,
        CAST(f.\`Total TDS Deposited(Rs.)\` AS SIGNED) AS total_tds,
        ROUND(IFNULL(SUM(a.Debits), 0) - IFNULL(SUM(a.Credits), 0), 2) AS erp_total
    FROM 
        tds.form_26as f
    LEFT JOIN 
        tds.accpac a 
        ON f.\`TAN of Deductor\` = a.tan AND a.tan != '-'
    GROUP BY 
        f.\`TAN of Deductor\`, f.\`Name of Deductor\`, f.\`Total TDS Deposited(Rs.)\`
) AS sub

where round(ABS(sub.erp_total - sub.total_tds),2) != 0
ORDER BY 
    difference desc;
`

    console.log("bankquery",bankquery)
    setBankquery(bankquery);
    setERPquery(erpquery);
    setDifferencequery(differencequery);
    getKpiinfo();
    getagingdashboard();
    getKpiinfo1();
    getAccountclosuredetails();
    getautomatchdetails();
    getVarianceinfo();
    getdifferenceinfo();
    getVarianceinfo1();
  },[selectedBank, selectedEntity,lastDate]);

const roundToNearest = (value,multiple) => {
  // Round value to the nearest 200,000 (or any other multiple you'd prefer)
  return Math.round(value / multiple) * multiple;
};

const minVariance = Math.min(...doughnutdata3);  // Add 10% padding for negative values
const maxVariance = Math.max(...doughnutdata3);  // Add 10% padding for positive values
const allData = [
  ...annexure1Data,
  ...annexure2Data,
  ...annexure3Data,
  ...annexure4Data
];

// Calculate the minimum and maximum values dynamically
const minVariance1 = Math.min(...doughnutdata4);
const maxVariance1 = Math.max(...doughnutdata4);


const chartDatanew2 = {
  options: {
    chart: {
      type: 'line',  // Line chart type
      height: 350,  // Set the chart height
    },
    stroke: {
      curve: 'smooth', // Smooth curve for the line
      width: 3,        // Line thickness
    },
    xaxis: {
      categories: doughnutLabel3,  // Categories (e.g., months or periods)
      title: {
        text: 'Month',  // Label for x-axis
      },
    },
    yaxis: {
      title: {
        text: 'Variance',  // Label for y-axis
      },
      min: roundToNearest(minVariance/10000000,1),  // Dynamically set the min value of the y-axis (rounded)
      max: roundToNearest(maxVariance/10000000,1),  // Dynamically set the max value of the y-axis (rounded)
      labels: {
                formatter: function (value) {
          if (value !== undefined && value !== null) {
		let roundedValue =  roundToNearest(value * 10000000, 10000000);  // Convert back to full value for display
                return (value).toLocaleString() + ' C';  // Display in lakhs (e.g., 134 L)
      	  }
      return '';  // Return an empty string if the value is undefined or null
        },

      },
    }, 
   tooltip: {
       y: {
        formatter: function (val) {
          if (val !== undefined && val !== null) {
          // Convert the value to crores
          return (val ).toFixed(2) + ' Cr';  // Format the value in crores
        }
        return '';
        // Format tooltip values as currency
        },
      },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'center',
    },
    grid: {
      borderColor: '#f1f1f1',
    },
    dataLabels: {
      enabled: false,  // Disable data labels if you don't want to display values directly on the chart
    },
    markers: {
      size: 5,  // Marker size at data points
      colors: ['#ff4560', '#00e396'],  // Custom colors for markers
    },
  },
  series: [
    {
      name: 'Variance',
      data: doughnutdata3.map(value => value / 10000000),  // Use the dynamic variance data
    },
  ],
};

const chartDatanew21 = {
  options: {
    chart: {
      type: 'line',  // Line chart type
      height: 350,  // Set the chart height
    },
    stroke: {
      curve: 'smooth', // Smooth curve for the line
      width: 3,        // Line thickness
    },
    xaxis: {
      categories: doughnutLabel4,  // Categories (e.g., months or periods)
      title: {
        text: 'Month',  // Label for x-axis
      },
    },
    yaxis: {
      title: {
        text: 'Variance',  // Label for y-axis
      },
      labels:  {
      formatter: function (val) {
        // Convert the value to crores and return formatted label
        return (val / 10000000).toFixed(2) + ' Cr'; // Format the Y-axis labels in crores
      },

      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          if (val !== undefined && val !== null) {
          // Convert the value to crores
          return (val / 10000000).toFixed(2) + ' Cr';  // Format the value in crores
        }
        return '';
        // Format tooltip values as currency
        },
      },
    },
    legend: {
      position: 'bottom',
      horizontalAlign: 'center',
    },
    grid: {
      borderColor: '#f1f1f1',
    },
    dataLabels: {
      enabled: false,  // Disable data labels if you don't want to display values directly on the chart
    },
    markers: {
      size: 5,  // Marker size at data points
      colors: ['#ff4560', '#00e396', '#3f51b5', '#9c27b0'],  // Custom colors for markers (one for each annexure)
    },
  },
  series: [
          { name: 'Annexure 1', data: annexure1Data },
          { name: 'Annexure 2', data: annexure2Data },
          { name: 'Annexure 3', data: annexure3Data },
          { name: 'Annexure 4', data: annexure4Data },
  ],
};


  const chartDatanew1 = {
    series: doughnutdata1,
    options: {
      labels: doughnutLabel1,
      colors: ['#DB6B3C', '#9B1B30', '#0A2352', '#b84dff', '#ff944d', '#00cccc', '#3E4C5E', '#4381C1', '#80A1C1', '#C7D3DD'],
      legend: {
        onItemClick: {
          toggleDataSeries: false,
        },

      },
      chart: {
        width: 280,
        height: 370,
        type: 'donut',
                },
      plotOptions: {
        pie: {
          startAngle: -90,
          endAngle: 270
        },
      },
      dataLabels: {
        enabled: false
      },
      fill: {
        type: 'gradient',
      },
      // legend: doughnutLabel,
      title: {
        text: ''
      },

      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
            height: 250,
          },
          legend: {
            position: 'bottom'
          }
        }
      }],

    },
  };

  const intColumnDefs3 = React.useMemo(() => {
    if (extGridData && extGridData?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(extGridData[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs = [

        ...keys.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true
        })),
      ];
      setmodelcolumnnames(intColumnDefs);
      // console.log('intColumnDefs', intColumnDefs);
      return intColumnDefs;
    }
    return [];
  }, [extGridData]);

  function ageinginfo3() {
    let payload = {
      query : `select * from txbrs.erp where match_status = 'Unmatched';`
    }

    var getProcessingLayerDataWithStatus = Fetchexecutequery();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          // let data1 = data['outstanding_value'];
          setExtGridData(data);
          setShow(true);
          
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }

  function ageinginfo11() {
    let payload = {
      query : `select * from txbrs.bank where match_status = 'Unmatched';`
    }

    var getProcessingLayerDataWithStatus = Fetchexecutequery();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          // let data1 = data['outstanding_value'];
          setExtGridData(data);
          setShow(true);
          
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }
  function getKpiinfo3() {
  
          setShow(true);
        }

  function getKpiinfo4() {
    
          setShow(true);
       
  }

  const handleBarClick1 = (event, chartContext, config) => {
    console.log('clicked');
    ageinginfo11();
  };

  const handleBarClick = (event, chartContext, config) => {
    console.log('clicked');
    // getKpiinfo4();
    ageinginfo3()
  };

  const chartData2 = {
    series: [
      {
        name: 'Series 1',
        data: seriesdata1,
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 250,
        toolbar: {
          show: false // Hide the toolbar
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          endingShape: 'rounded',
          columnWidth: barwidth
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: serieslabels1,
      },
      yaxis: {
        labels: {
          formatter: function (value) {
            // Format the y-axis labels as lakhs
            return (value / 1);
          },
        },
      },
      fill: {
        colors: ['#0a2352'],
      },
    },
  };

  const [totalsales, settotalsales] = useState('')
  const [overdueamount, setoverdueamount] = useState('')

  function getKpiinfo() {

    let query = `select \`TAN of Deductor\` as tan,\`Total TDS Deposited\` as difference,0 as age_bucket  from tx26.as_summary order by \`Total TDS Deposited\` desc limit 10;`

    let payload = {
      query : query
    }
    var getProcessingLayerDataWithStatus = Fetchexecutequery();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("aging dashboard data!!!", response)
          let data = response["data"];
          let filteredData = data;
          let bucketCounts = {
                '0-30 Days': 0,
                '31-60 Days': 0,
                '61-90 Days': 0,
                '90+ Days': 0
            };

            filteredData.forEach(item => {
                // Ensure 'age_bucket' is used to populate the counts
                if (bucketCounts.hasOwnProperty(item.age_bucket)) {
                    bucketCounts[item.age_bucket] = item.value;
                }
            });

            // Convert bucketCounts object to arrays for labels and series
            const labels = filteredData.map(item => item["tan"]);
            const series = filteredData.map(item => item.difference);

            console.log("bankbucket",series)
          setbankData2(series);
          setserieslabels(labels);
          setseriesdata(series);
          setTanDeductors(labels);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }

  function getdifferenceinfo() {

    let query = `SELECT 
    sub.tan,
    sub.erp_total,
    sub.total_tds,
    ROUND(ABS(sub.erp_total - sub.total_tds),2) AS difference
FROM (
    SELECT 
        f.\`tan_no\` AS tan,
        f.customer_name,
        f.\`Total TDS Deposited\` AS total_tds,
        ROUND(IFNULL(SUM(a.NetAmt), 0), 2) AS erp_total
    FROM 
        tx26.as_summary f
    LEFT JOIN 
        tx26.gl a 
        ON f.\`customer_code\` = a.\`party code\` 
        AND f.customer_code IS NOT NULL
    GROUP BY 
        f.\`tan_no\`, f.customer_name, f.\`Name of Deductor\`, f.\`Total TDS Deposited\`
) AS sub
WHERE 
    ROUND(ABS(sub.erp_total - sub.total_tds),2) != 0
ORDER BY 
    difference DESC 
LIMIT 10;

`

    let payload = {
      query : query
    }
    var getProcessingLayerDataWithStatus = Fetchexecutequery();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("as difference data!!!", response)
          let data = response["data"];
          let filteredData = data;

            // Convert bucketCounts object to arrays for labels and series
            const labels = filteredData.map(item => item["tan"]);
            const series = filteredData.map(item => item.erp_total);
            const series1 = filteredData.map(item => item.total_tds);

          console.log("bankbucket",series)
          seterpDifference(series);
          setbankDifference(series1);
          setTanDifference(labels);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }



  function getagingdashboard() {
    let query = `SELECT \`party code\` as tan,sum(\`NetAmt\`) as total_tds,0 as age_bucket FROM tx26.gl where \`party code\` is not null and match_status = 'Unmatched' group by \`party code\` order by \`total_tds\` desc limit 10;`

    let payload = {
      query : query
    }


    var getProcessingLayerDataWithStatus = Fetchexecutequery();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {

          let data = response["data"];
          console.log("ERP aging dashboard data!!!", data)
          let filteredData = data;
          let bucketCounts = {
                '0-30 Days': 0,
                '31-60 Days': 0,
                '61-90 Days': 0,
                '90+ Days': 0
            };

            filteredData.forEach(item => {
                // Ensure 'age_bucket' is used to populate the counts
                if (bucketCounts.hasOwnProperty(item.age_bucket)) {
                    // Ensure the value is numeric and then format it
                    let value = parseFloat(item.value);
                    bucketCounts[item.age_bucket] = item.total_value;
                  }
            });

            // Convert filteredData to labels and series based on TAN of Deductor
            const labels = data.map(item => item["tan"]);
            const series = data.map(item => item.total_tds);
            console.log("bankbucket",series,labels)

          setserieslabels1(labels);
          setseriesdata1(series);
          seterpData1(series);
          seterpTanDeductors(labels);

          let arrayLength = [];
          let datesArray = labels;
          arrayLength = datesArray && datesArray?.length;

          if (arrayLength == 3) {
            setbarwidth('40%')
          } else if (arrayLength == 2) {
            setbarwidth('30%')
          } else if (arrayLength == 1) {
            setbarwidth('10%')
          }
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }

  const [item, setitem] = useState({});
  const [item1, setitem1] = useState({});
  const [item2, setitem2] = useState({});
  const [item3, setitem3] = useState({});
  const [item4, setitem4] = useState('');
  const [item5, setitem5] = useState('');
  const [item6, setitem6] = useState('');
  const [item7, setitem7] = useState('');
  const [urls, seturls] = useState([]);

  const [show19, setshow19] = useState(true);


  function getKpiinfo1() {
    let query =  `SELECT close_status, COUNT(*) AS count FROM txbrs.month_end_balance where month = '${selectedMonth}-${selectedYear}' and gl_code in (select gl_code from txbrs.account_master `

    // Add bank and entity conditions right before the HAVING clause
    if (selectedBank && selectedEntity && selectedBank.length > 0 && selectedEntity.length > 0) {
	const bankValues = selectedBank.map(bank => `'${bank.value}'`); // Get only the 'value' property
	const entityValues = selectedEntity.map(entity => `'${entity.value}'`); // Get only the 'value' property
        query += `where Bank IN (${bankValues}) AND Entity IN (${entityValues}))`;
    } else if (selectedBank && selectedBank.length > 0) {
	const bankValues = selectedBank.map(bank => `'${bank.value}'`); // Get only the 'value' property
        query += `where Bank IN (${bankValues}))`;
    } else if (selectedEntity  && selectedEntity.length > 0) {
	const entityValues = selectedEntity.map(entity => `'${entity.value}'`); // Get only the 'value' property
        query += `where Entity IN (${entityValues}))`;
    } else {
        query += `)`;
    }
    
    // Add HAVING clause
    query += ` GROUP BY close_status;`;

    let payload = {
      query : query
    }

    var getProcessingLayerDataWithStatus = Fetchexecutequery();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          const status = data.map(item => item.close_status);
          const Count = data.map(item => item.count);
          setDoughnutLabel(status);
          setDoughnutData(Count)

        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }

  function getVarianceinfo() {
    let query =  `SELECT 
    month,
    SUM(CAST(erp_closing_balance AS DECIMAL(20, 2))) AS sum_erp_closing_balance,
    SUM(CAST(bank_closing_balance AS DECIMAL(20, 2))) AS sum_bank_closing_balance,
    SUM(CAST(bank_closing_balance AS DECIMAL(20, 2))) - SUM(CAST(erp_closing_balance AS DECIMAL(20, 2))) AS variance
FROM txbrs.month_end_balance
WHERE 
    STR_TO_DATE(CONCAT(LPAD(SUBSTRING_INDEX(month, '-', 1), 2, '0'), '-01-', SUBSTRING_INDEX(month, '-', -1)), '%m-%d-%Y') 
    <= STR_TO_DATE(CONCAT(LPAD('${selectedMonth}', 2, '0'), '-01-', '${selectedYear}'), '%m-%d-%Y')
 and gl_code in (select gl_code from txbrs.account_master `

    // Add bank and entity conditions right before the HAVING clause
    if (selectedBank && selectedEntity && selectedBank.length > 0 && selectedEntity.length > 0) {
	const bankValues = selectedBank.map(bank => `'${bank.value}'`); // Get only the 'value' property
	const entityValues = selectedEntity.map(entity => `'${entity.value}'`); // Get only the 'value' property
        query += `where Bank IN (${bankValues}) AND Entity IN (${entityValues}))`;
    } else if (selectedBank && selectedBank.length > 0) {
	const bankValues = selectedBank.map(bank => `'${bank.value}'`); // Get only the 'value' property
        query += `where Bank IN (${bankValues}))`;
    } else if (selectedEntity  && selectedEntity.length > 0) {
	const entityValues = selectedEntity.map(entity => `'${entity.value}'`); // Get only the 'value' property
        query += `where Entity IN (${entityValues}))`;
    } else {
        query += `)`;
    }
    
    // Add HAVING clause
    query += ` GROUP BY month ORDER BY STR_TO_DATE(CONCAT('01-', month), '%d-%m-%Y') desc limit 6;`;

    let payload = {
      query : query
    }

    var getProcessingLayerDataWithStatus = Fetchexecutequery();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          let data = response["data"];
          data.reverse();
          const status = data.map(item => item.month);
          const Count = data.map(item => item.variance);
          setDoughnutLabel3(status);
          setDoughnutData3(Count)

        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }


  function getVarianceinfo1() {
    let query =  `WITH FilteredERP AS (
    SELECT 
        *,STR_TO_DATE(\`gl date\`, '%d-%b-%Y') AS gl_date_converted
    FROM txbrs.erp
    WHERE match_status = 'Unmatched'
),
FilteredBank AS (
    SELECT 
        *,STR_TO_DATE(\`entry date\`, '%d-%b-%Y') AS entry_date_converted
    FROM txbrs.bank
    WHERE match_status = 'Unmatched'
),
MatchingContraERP AS (
    SELECT 
        match_id, 
        primary_id 
    FROM 
        txbrs.erp
    WHERE 
        match_status = 'Contra'
),
MatchingContraBank AS (
    SELECT 
        match_id, 
        primary_id
    FROM 
        txbrs.bank
    WHERE 
        match_status = 'Contra'
)
SELECT 
    annexure_type,
    age_group,
    sum(total_value) as total_value,
    COUNT(*) AS count
FROM (
    SELECT 
        CASE 
            WHEN a.\`credit amt\` = 0 THEN 'annexure 2'
            WHEN a.\`debit amt\` = 0 THEN 'annexure 3'
        END AS annexure_type,SUM(CAST(a.\`credit amt\` AS FLOAT) + CAST(a.\`debit amt\` AS FLOAT)) as total_value,a.glcd as gl_code,
        CASE
            WHEN DATEDIFF(CURDATE(), a.gl_date_converted) <= 30 THEN '0-30'
            WHEN DATEDIFF(CURDATE(), a.gl_date_converted) BETWEEN 31 AND 60 THEN '31-60'
            WHEN DATEDIFF(CURDATE(), a.gl_date_converted) BETWEEN 61 AND 90 THEN '61-90'
            ELSE '90+'
        END AS age_group
    FROM 
        FilteredERP a
    WHERE glcd is not null and 
        (
            (a.match_status = 'Unmatched' AND MONTH(a.gl_date_converted) <= STR_TO_DATE('${lastDate}', '%d-%b-%Y') 
               )
        ) group by  annexure_type,age_group,gl_code
    
    UNION ALL
    
    SELECT 
        CASE
            WHEN a.Credit = 0 THEN 'annexure 1'
            WHEN a.Debit = 0 THEN 'annexure 4'
        END AS annexure_type,SUM(a.Credit + a.Debit) as total_value,a.gl_code as gl_code,
        CASE
            WHEN DATEDIFF(CURDATE(), a.entry_date_converted) <= 30 THEN '0-30'
            WHEN DATEDIFF(CURDATE(), a.entry_date_converted) BETWEEN 31 AND 60 THEN '31-60'
            WHEN DATEDIFF(CURDATE(), a.entry_date_converted) BETWEEN 61 AND 90 THEN '61-90'
            ELSE '90+'
        END AS age_group
    FROM 
        FilteredBank a
    LEFT JOIN 
        FilteredERP e ON e.match_id = a.match_id
    LEFT JOIN 
        MatchingContraBank mc ON a.match_id = mc.match_id AND a.primary_id != mc.primary_id
    WHERE 
        gl_code is not null and (
            (a.match_status = 'Unmatched' AND a.entry_date_converted <= STR_TO_DATE('${lastDate}', '%d-%b-%Y')
                AND YEAR(a.entry_date_converted) <= '${selectedYear}')
            OR 
            (a.match_id IS NOT NULL AND a.match_status IN ('Match') 
                AND a.entry_date_converted <= STR_TO_DATE('${lastDate}', '%d-%b-%Y')
                AND YEAR(a.entry_date_converted) <= '${selectedYear}' 
                AND e.match_id IS NULL)
            OR 
            (a.match_id IS NOT NULL AND a.match_status IN ('Group Match', 'group unmatched', 'Groupmatch') 
                AND e.match_id IS NULL)
            OR 
            (a.match_id IS NOT NULL AND a.match_status = 'Contra'
                AND a.entry_date_converted <= STR_TO_DATE('${lastDate}', '%d-%b-%Y') 
                AND YEAR(a.entry_date_converted) <= '${selectedYear}' 
                AND mc.match_id IS NULL))
          group by  annexure_type,age_group,gl_code

) AS CombinedData

where gl_code in (select gl_code from txbrs.account_master `

    // Add bank and entity conditions right before the HAVING clause
    if (selectedBank && selectedEntity && selectedBank.length > 0 && selectedEntity.length > 0) {
	const bankValues = selectedBank.map(bank => `'${bank.value}'`); // Get only the 'value' property
	const entityValues = selectedEntity.map(entity => `'${entity.value}'`); // Get only the 'value' property
        query += `where Bank IN (${bankValues}) AND Entity IN (${entityValues}) and is_active = 1)`;
    } else if (selectedBank && selectedBank.length > 0) {
	const bankValues = selectedBank.map(bank => `'${bank.value}'`); // Get only the 'value' property
        query += `where Bank IN (${bankValues}) and is_active = 1)`;
    } else if (selectedEntity  && selectedEntity.length > 0) {
	const entityValues = selectedEntity.map(entity => `'${entity.value}'`); // Get only the 'value' property
        query += `where Entity IN (${entityValues}) and is_active = 1)`;
    } else {
        query += `where is_active = 1)`;
    }
    
    // Add HAVING clause
    query += ` GROUP BY 
    annexure_type, 
    age_group
ORDER BY 
    annexure_type, 
    age_group;
;`;


    let payload = {
      query : query
    }

    var getProcessingLayerDataWithStatus = Fetchexecutequery();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status annexure aging!!!", response)
          let data = response["data"];
          console.log("annexure data",data)
          const groupedData = data.reduce((acc, item) => {
            if (!acc[item.annexure_type]) {
              acc[item.annexure_type] = {};
            }
            acc[item.annexure_type][item.age_group] = item.total_value;
            return acc;
          }, {});

            // Step 2: Define the age groups for the x-axis
            const categories = ["0-30", "31-60", "61-90", "90+"];  // Age groups

            // Step 3: Extract and set the labels and counts for the doughnut chart
            // Assuming you want the age groups for the doughnut chart
            const status = categories;  // The age groups are the status (categories)
            const countForDoughnut = categories.map(ageGroup => {
            // Sum the counts for each age group across all annexures
            return data.filter(item => item.age_group === ageGroup).reduce((sum, item) => sum + item.total_value, 0);
          });

          // Set the doughnut labels and data
          const annexure1Data = categories.map(ageGroup => groupedData["annexure 1"] && groupedData["annexure 1"][ageGroup] !== undefined ? groupedData["annexure 1"][ageGroup] : 0);
          const annexure2Data = categories.map(ageGroup => groupedData["annexure 2"] && groupedData["annexure 2"][ageGroup] !== undefined? groupedData["annexure 2"][ageGroup] : 0);
          const annexure3Data = categories.map(ageGroup => groupedData["annexure 3"] && groupedData["annexure 3"][ageGroup] !== undefined? groupedData["annexure 3"][ageGroup] : 0);
          const annexure4Data = categories.map(ageGroup => groupedData["annexure 4"] && groupedData["annexure 4"][ageGroup] !== undefined? groupedData["annexure 4"][ageGroup] : 0);
	  console.log("Annexure 1 Data:", annexure1Data);
	  console.log("Annexure 2 Data:", annexure2Data);
	  console.log("Annexure 3 Data:", annexure3Data);
	  console.log("Annexure 4 Data:", annexure4Data);

          setDoughnutLabel4(status);
          setDoughnutData4([annexure1Data, annexure2Data, annexure3Data, annexure4Data]);

setAnnexure1Data(annexure1Data);
setAnnexure2Data(annexure2Data);
setAnnexure3Data(annexure3Data);
setAnnexure4Data(annexure4Data);

        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }


  function getAccountclosuredetails() {
    let query = `SELECT 
    CASE 
        WHEN close_status = 0 THEN 'Open'
        WHEN close_status = 1 THEN 'Closed'
        WHEN close_status = 2 THEN 'Freezed'
    END AS close_status,
    COUNT(*) AS count
FROM txbrs.month_end_balance where month = '${selectedMonth}-${selectedYear}' and gl_code in (select gl_code from txbrs.account_master `

    // Add bank and entity conditions right before the HAVING clause
    if (selectedBank && selectedEntity && selectedBank.length > 0 && selectedEntity.length > 0) {
	const bankValues = selectedBank.map(bank => `'${bank.value}'`); // Get only the 'value' property
	const entityValues = selectedEntity.map(entity => `'${entity.value}'`); // Get only the 'value' property
        query += `where Bank IN (${bankValues}) AND Entity IN (${entityValues}))`;
    } else if (selectedBank && selectedBank.length > 0) {
	const bankValues = selectedBank.map(bank => `'${bank.value}'`); // Get only the 'value' property
        query += `where Bank IN (${bankValues}))`;
    } else if (selectedEntity  && selectedEntity.length > 0) {
	const entityValues = selectedEntity.map(entity => `'${entity.value}'`); // Get only the 'value' property
        query += `where Entity IN (${entityValues}))`;
    } else {
        query += `)`;
    }
    
    // Add HAVING clause
    query += ` GROUP BY close_status;`;

    let payload = {
      query : query
    }

    var getProcessingLayerDataWithStatus = Fetchexecutequery();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Account Closure Status!!!", response)
          let data = response["data"];
          const gl_code = data.map(item => item.close_status);
          const divisionCount = data.map(item => item.count);    
          setDoughnutLabel1(gl_code);
          setDoughnutData1(divisionCount)
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }


  useEffect(() => {

    // BrsTypeList();
    getKpiinfo();
    getKpiinfo1();
    getagingdashboard();
    BankList();
    getAccountclosuredetails();
    getautomatchdetails();
    getVarianceinfo();
    getVarianceinfo1();
  }, []
  );



  const handleIconClick5 = () => {
    // Redirect to the desired URL
    window.location.href = '/demobrs'; // Replace with your URL
  };

  const handleClose = () => {
    setShow(false);
  };

function getautomatchdetails() {
    let query = `SELECT 
    CASE 
        WHEN automatch = 0 THEN 'Manual'
        WHEN automatch = 1 THEN 'Automatch'
    END AS automatch,
    COUNT(*) AS count
FROM txbrs.erp where month(STR_TO_DATE(\`gl date\`, '%d-%b-%Y'))= '${selectedMonth}' and year(STR_TO_DATE(\`gl date\`, '%d-%b-%Y')) = '${selectedYear}' and glcd in (select gl_code from txbrs.account_master `

    // Add bank and entity conditions right before the HAVING clause
    if (selectedBank && selectedEntity && selectedBank.length > 0 && selectedEntity.length > 0) {
	const bankValues = selectedBank.map(bank => `'${bank.value}'`); // Get only the 'value' property
	const entityValues = selectedEntity.map(entity => `'${entity.value}'`); // Get only the 'value' property
        query += `where Bank IN (${bankValues}) AND Entity IN (${entityValues}))`;
    } else if (selectedBank && selectedBank.length > 0) {
	const bankValues = selectedBank.map(bank => `'${bank.value}'`); // Get only the 'value' property
        query += `where Bank IN (${bankValues}))`;
    } else if (selectedEntity  && selectedEntity.length > 0) {
	const entityValues = selectedEntity.map(entity => `'${entity.value}'`); // Get only the 'value' property
        query += `where Entity IN (${entityValues}))`;
    } else {
        query += `)`;
    }
    
    // Add HAVING clause
    query += ` GROUP BY automatch`;


    let query1 = `UNION ALL
SELECT 
    CASE 
        WHEN automatch = 0 THEN 'Manual'
        WHEN automatch = 1 THEN 'Automatch'
    END AS automatch,
    COUNT(*) AS count
FROM txbrs.bank where month(STR_TO_DATE(\`entry date\`, '%d-%b-%Y'))= '${selectedMonth}' and year(STR_TO_DATE(\`entry date\`, '%d-%b-%Y')) = '${selectedYear}' and gl_code in (select gl_code from txbrs.account_master `

    // Add bank and entity conditions right before the HAVING clause
    if (selectedBank && selectedEntity && selectedBank.length > 0 && selectedEntity.length > 0) {
	const bankValues = selectedBank.map(bank => `'${bank.value}'`); // Get only the 'value' property
	const entityValues = selectedEntity.map(entity => `'${entity.value}'`); // Get only the 'value' property
        query1 += `where Bank IN (${bankValues}) AND Entity IN (${entityValues}))`;
    } else if (selectedBank && selectedBank.length > 0) {
	const bankValues = selectedBank.map(bank => `'${bank.value}'`); // Get only the 'value' property
        query1 += `where Bank IN (${bankValues}))`;
    } else if (selectedEntity  && selectedEntity.length > 0) {
	const entityValues = selectedEntity.map(entity => `'${entity.value}'`); // Get only the 'value' property
        query1 += `where Entity IN (${entityValues}))`;
    } else {
        query1 += `)`;
    }
    
    // Add HAVING clause
    query1 += ` GROUP BY automatch;`;


    let payload = {
      query : `${query} ${query1}`
    }

    var getProcessingLayerDataWithStatus = Fetchexecutequery();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          const automatchCount = data.find(item => item.automatch === 'Automatch')?.count || 0;
            const manualCount = data.find(item => item.automatch === 'Manual')?.count || 0;

            // Calculate total count
            const totalCount = automatchCount + manualCount;

            // Calculate percentages
            const automatchPercentage = totalCount > 0 ? ((automatchCount / totalCount) * 100).toFixed(2) : '0.00';
            const manualPercentage = totalCount > 0 ? ((manualCount / totalCount) * 100).toFixed(2) : '0.00';

            // Log the percentages (for debugging)
            console.log("Automatch Percentage: ", automatchPercentage);
            console.log("Manual Percentage: ", manualPercentage);

            // Set Doughnut chart data
            setDoughnutLabel2(['Automatch', 'Manual']);
            setDoughnutData2([parseFloat(automatchPercentage), parseFloat(manualPercentage)]);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }

  function getExceptiontypedata1_1(query1) {
    let payload = {
      query: query1

    }

    var getProcessingLayerDataWithStatus = Fetchexecutequery();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          setExtGridData(data);
          setShow(true);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }


  function BankList() {
    let payload = {
      query: "select * from txbrs.account_master;"
    };

    const getProcessingLayerList = Fetchexecutequery();
    console.log("brs", getProcessingLayerList);

    axios.post(getProcessingLayerList[1], payload, getProcessingLayerList[0])
      .then(response => {
        console.log("Processing customer List vendor code!!!", response);

        let data = response["data"];
        console.log('data', data);

        if (data) {
          // Extract unique banks and unique entity IDs
          const uniqueBanks = [...new Set(data.map(item => item.Bank))];
          const uniqueEntities = [...new Set(data.map(item => item.Entity))];

          // Set bank and entity options
          setbankOptions(uniqueBanks);
          setEntityOptions(uniqueEntities);

          // Create a mapping of banks to their corresponding entity IDs
          const bankEntityMap = data.reduce((acc, item) => {
            if (!acc[item.Bank]) {
              acc[item.Bank] = new Set();
            }
            acc[item.Bank].add(item.Entity);
            return acc;
          }, {});

          const entityBankMap = data.reduce((acc, item) => {
            if (!acc[item.Entity]) {
              acc[item.Entity] = new Set();
            }
            acc[item.Entity].add(item.Bank);
            return acc;
          }, {});

          setBankEntityMapping(bankEntityMap);
          setEntityBankMapping(entityBankMap);

          // Initialize filtered options to show all initially
          setFilteredbankOptions(uniqueBanks);
          setFilteredEntityOptions(uniqueEntities);
        }
      })
      .catch(error => {
        console.log("Error in Processing Layer List!!!", error);
      })};

  // Filter entities based on selected bank
const handleBankChange = (selectedBank) => {
    setSelectedBank(selectedBank); // Set the selected bank (as an object)
    console.log("bankoptions",bankOptions,selectedBank);
  let relatedEntities ;
  if (selectedBank&& selectedBank.length > 0) {
    // Filter banks that are related to any of the selected entities
    console.log("bankOptions", bankOptions, bankEntityMapping);
    relatedEntities = entityOptions.filter(entity => {
      // Check if any of the selected entities are related to the bank
      return selectedBank.some(bank => 
        entityBankMapping[entity] && entityBankMapping[entity].has(bank.value)
      );
    });
  } else {
    // If no selected entities, return all bank options
    relatedEntities = entityOptions;
  }
    setFilteredEntityOptions(relatedEntities); // Update the filtered bank options
    console.log("relatedEntities",relatedEntities); // Log the related banks for debugging
    // If the selected bank is no longer valid, reset it
};

  // Filter banks based on selected entity
const handleEntityChange = (selectedEntities) => {
  setSelectedEntity(selectedEntities); // Update the selected entities
  console.log("selectedEntity", selectedEntities);

  let relatedBanks; // Declare relatedBanks variable once

  if (selectedEntities && selectedEntities.length > 0) {
    // Filter banks that are related to any of the selected entities
    console.log("bankOptions", bankOptions, bankEntityMapping);

    relatedBanks = bankOptions.filter(bank => {
      // Check if any of the selected entities are related to the bank
      return selectedEntities.some(entity => 
        bankEntityMapping[bank] && bankEntityMapping[bank].has(entity.value)
      );
    });
  } else {
    // If no selected entities, return all bank options
    relatedBanks = bankOptions;
  }
  console.log("relatedBanks",relatedBanks);
  setFilteredbankOptions(relatedBanks); // Update the filtered bank options
  console.log(relatedBanks); // Log the related banks for debugging
};


useEffect(() => {
  let relatedBanks; // Declare relatedBanks variable once
  // Only filter if selectedEntities is not empty
  if (selectedEntity && selectedEntity.length > 0) {
    console.log("bankOptions", bankOptions, bankEntityMapping); 
    // Filter banks based on selected entities
    relatedBanks = bankOptions.filter(bank => {
      // Check if the bank is related to any of the selected entities
      return selectedEntity.some(entity => 
        bankEntityMapping[bank] && bankEntityMapping[bank].has(entity.value)
      );
    });
  } else {
    // If no selected entities, return all bank options
    relatedBanks = bankOptions;
  }
  // Update the filtered bank options with the result
  setFilteredbankOptions(relatedBanks);
}, [selectedEntity]);  // Only depend on selectedEntities


useEffect(() => {
  let relatedEntities ;
  if (selectedBank&& selectedBank.length > 0) {
    // Filter banks that are related to any of the selected entities
    console.log("bankOptions", bankOptions, bankEntityMapping);
    relatedEntities = entityOptions.filter(entity => {
      // Check if any of the selected entities are related to the bank
      return selectedBank.some(bank => 
        entityBankMapping[entity] && entityBankMapping[entity].has(bank.value)
      );
    });
  } else {
    // If no selected entities, return all bank options
    relatedEntities = entityOptions;
  }
    setFilteredEntityOptions(relatedEntities);
}, [selectedBank]);  // Only depend on selectedEntities




const getclosestatus= (event) => {
  // Get the target element which corresponds to the clicked donut segment
  const targetElement = event.target;
  console.log(targetElement); // Inspect the target element

  // Extract the index from the target element's attributes
  const segmentIndex = targetElement.getAttribute('j');
  console.log("Extracted Segment Index:", segmentIndex);  // Logs the index of the clicked segment

  // Proceed only if the segment index is available
  if (segmentIndex !== null && segmentIndex !== undefined) {
    const selectedIndex = parseInt(segmentIndex, 10);  // Convert the index to an integer
    let selectedLabel = chartDatanew1.options.labels[selectedIndex];
    console.log("Selected Label:", selectedLabel);  // Logs the label corresponding to the index
    if (selectedLabel === 'Open') {
    selectedLabel = '0';  // Assign 0 if selectedLabel is 'Open'
    } else if (selectedLabel === 'Freezed') {
    selectedLabel = '2';  // Assign 0 if selectedLabel is 'Open'
    } else {
    selectedLabel = '1';  // Assign 1 if selectedLabel is anything other than 'Open'
    }

    // Use the selected label to create a query
    let query = `SELECT  Entity,bank_name,account_no,gl_code,month,FORMAT(erp_opening_balance, 2) AS erp_opening_balance,FORMAT(bank_opening_balance, 2) AS bank_opening_balance, 
    FORMAT(erp_closing_balance, 2) AS erp_closing_balance, FORMAT(bank_closing_balance, 2) AS bank_closing_balance,closed_by,closed_date  FROM txbrs.month_end_balance WHERE month = '${selectedMonth}-${selectedYear}' and close_status = '${selectedLabel}'`;
    if (selectedBank && selectedEntity && selectedBank.length > 0 && selectedEntity.length > 0) {
    const bankValues = selectedBank.map(bank => `'${bank.value}'`); // Get only the 'value' property
    const entityValues = selectedEntity.map(entity => `'${entity.value}'`); // Get only the 'value' property
    query += ` AND bank_name in (${bankValues}) AND Entity in (${entityValues});`;
  } else if (selectedBank && selectedBank.length > 0) {
    const bankValues = selectedBank.map(bank => `'${bank.value}'`); // Get only the 'value' property
    query += ` AND bank_name in (${bankValues});`;
  } else if (selectedEntity && selectedEntity.length > 0) {
    const entityValues = selectedEntity.map(entity => `'${entity.value}'`); // Get only the 'value' property
    query += ` AND Entity in (${entityValues});`;
  } else {
    query += `;`;
     }
    console.log("Query:", query);  // Log the generated query to verify
    getExceptiontypedata1_1(query);  // Execute the query (replace with your actual function)
  } else {
    console.log("Index is not found in the target element.");
  }
};

const getMatchrecords= (event) => {
  // Get the target element which corresponds to the clicked donut segment
  const targetElement = event.target;
  console.log(targetElement); // Inspect the target element

  // Extract the index from the target element's attributes
  const segmentIndex = targetElement.getAttribute('j');
  console.log("Extracted Segment Index:", segmentIndex);  // Logs the index of the clicked segment

  // Proceed only if the segment index is available
  if (segmentIndex !== null && segmentIndex !== undefined) {
    const selectedIndex = parseInt(segmentIndex, 10);  // Convert the index to an integer
    let selectedLabel = chartDatanew1.options.labels[selectedIndex];
    console.log("Selected Label:", selectedLabel);  // Logs the label corresponding to the index
    if (selectedLabel === 'Automatch') {
    selectedLabel = '1';  // Assign 0 if selectedLabel is 'Open'
    } else {
    selectedLabel = '0';  // Assign 1 if selectedLabel is anything other than 'Open'
    }

    // Use the selected label to create a query
    let query = `SELECT  Entity,bank_name,account_no,gl_code,month,erp_opening_balance,bank_opening_balance,erp_closing_balance,bank_closing_balance,closed_by,closed_date  FROM txbrs.month_end_balance WHERE month = '${selectedMonth}-${selectedYear}' and close_status = '${selectedLabel}'`;
    if (selectedBank && selectedEntity && selectedBank.length > 0 && selectedEntity.length > 0) {
    const bankValues = selectedBank.map(bank => `'${bank.value}'`); // Get only the 'value' property
    const entityValues = selectedEntity.map(entity => `'${entity.value}'`); // Get only the 'value' property
    query += ` AND bank_name in (${bankValues}) AND Entity in (${entityValues});`;
  } else if (selectedBank && selectedBank.length > 0) {
    const bankValues = selectedBank.map(bank => `'${bank.value}'`); // Get only the 'value' property
    query += ` AND bank_name in (${bankValues});`;
  } else if (selectedEntity && selectedEntity.length > 0) {
    const entityValues = selectedEntity.map(entity => `'${entity.value}'`); // Get only the 'value' property
    query += ` AND Entity in (${entityValues});`;
  } else {
    query += `;`;
     }
    console.log("Query:", query);  // Log the generated query to verify
    getExceptiontypedata1_1(query);  // Execute the query (replace with your actual function)
  } else {
    console.log("Index is not found in the target element.");
  }
};


  function exportJsonToXLSX(data, sheetName, excelFileName) {
    try {
      var workBook = XLSX.utils.book_new();
      var workSheet = XLSX.utils.json_to_sheet(data, {
        skipHeader: false,
      });
      XLSX.utils.book_append_sheet(workBook, workSheet, sheetName);
      XLSX.writeFile(workBook, excelFileName);
      return true;
    }
    catch
    {
      return false;
    }
  }

  function exportToExcel() {
    let fileNameChange = "Report.xlsx";
    let sheetName = "sheet";
    let excelExportData = [];

    for (let i = 0; i < extGridData?.length; i++) {
      let data = {};
      for (let key in extGridData[i]) {
        for (let j = 0; j < modelcolumnnames?.length; j++) {
          if (key === modelcolumnnames[j]["field"]) {
            data[modelcolumnnames[j]["headerName"]] = extGridData[i][key]
          }
        }
      }
      excelExportData.push(data);
    };
    exportJsonToXLSX(excelExportData, sheetName, fileNameChange);
  }

  const handleBankClick = (bankToDeselect) => {
    setSelectedBank(prevSelected =>
      prevSelected.filter(bank => bank.value !== bankToDeselect.value)
    );
  };

const handleBankClick1 = (bankToSelect) => {
  setSelectedBank(prevSelected => {
    // If the bank is not already selected, add it to the selected list
    if (!prevSelected.includes(bankToSelect)) {
      return [...prevSelected, {label:bankToSelect,value:bankToSelect}];
    }
    return prevSelected; // If it's already selected, do nothing
  });
};



const handleEntityClick1 = (entityToSelect) => {
  setSelectedEntity(prevSelected => {
    // If the bank is not already selected, add it to the selected list
    if (!prevSelected.includes(entityToSelect)) {
      return [...prevSelected, {label:entityToSelect,value:entityToSelect}];
    }
    return prevSelected; // If it's already selected, do nothing
  });
};


  // Function to handle deselecting an entity when clicked
  const handleEntityClick = (entityToDeselect) => {
    console.log("selectedEntity",selectedEntity)
    setSelectedEntity(prevSelected =>
      prevSelected.filter(entity => entity.value !== entityToDeselect.value)
    );
  };




  const cleckedcustomername = (value) => {
    // sidemenulist(value);
    // handleSelection123(value, clientids);
    console.log('clicked');
  }

  const chartState = {
    series: radialseries,
    options: {
      chart: {
        height: 200,
        type: 'radialBar',
        margin: 0,
      },
      plotOptions: {
        radialBar: {
          hollow: {
            margin: 0,
            size: '40%',
            background: '#0a2352',
          },
          dataLabels: {
            value: {
              color: '#fff',
              fontSize: '17px',
              show: true,
              offsetY: 0,
              align: 'center',
            },
            style: {
              fontSize: '160px',
              color: '#fff',
            },
          },
          fill: {
            type: 'solid',
            colors: ['#fffd01'],
          },
          stroke: {
            lineCap: 'round',
          },
        },
      },
      labels: [''],
      colors: ['#fffd01'],
    },
  };

  const [hoveredIndex, setHoveredIndex] = useState(null);

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  const truncateText = (text, maxChars) => {
    return text?.length > maxChars ? text?.slice(0, maxChars) + '...' : text;
  };

  function handlebankSelection(event) {
    const selectedBank = event;
    setSelectedBank(selectedBank);
}

  const handleDateChange = (event) => {
    const selectedMonth = event.target.value; // 'YYYY-MM' format
    console.log('selectedMonth',selectedMonth);
    setSelectedDate(selectedMonth); // Update state with the selected month
    const [year, month] = selectedMonth.split('-'); // Split into year and month
    const monthInt = parseInt(month, 10); // Convert month to an integer (e.g., 8 instead of '08')
    setSelectedMonth(monthInt);
    setSelectedYear(year);
  };
  const handleInput = (value) => {
    // Do something with the input value received from SearchInput component
    console.log('Input value:', value);
    let filteredData = options.filter(item =>
      item.label.toLowerCase().includes(value.toLowerCase())
    );
    setOptions1(filteredData);
  };

  return (
    <div id="dashboard1main" style={{ marginTop: '-1em'}}>

      <Grid className="mt-2 mb-2" style={{ marginLeft: '1em' }}>
        <Grid.Row>
          <Grid.Column style={{ width: '15%' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Select Month</label>
              <input
                type="month"
                name="month"
                value={selectedDate}
                className="date-picker"
                style={{
                  padding: '10px',
                  fontSize: '14px',
                  width: '100%',
                  maxWidth: '200px', // Reduced width
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                  height : '33px',
                  backgroundColor: '#fff',
                }}
                onChange={handleDateChange}
              />
            </div>
          </Grid.Column>
              <Grid.Column style={{ width: '7%' }}>
                <div class="wrapper" style={{ paddingTop: '2em', height: '95%', width: '100%' }} >
                  <div class="icon12 facebook" onClick={handleIconClick5} style={{ textAlign: 'center', cursor: 'pointer', position: 'relative' }}>
                    <div class="tooltip">
                      Recon Summary
                    </div>
                    <span><FontAwesomeIcon icon={faClipboard} style={{ fontSize: '24px',marginTop: '5px' }} /></span>


                  </div>
                </div>
              </Grid.Column>

        </Grid.Row>	
        <Grid.Row >
          <Grid.Column>   
              <Grid.Row style={{  marginLeft: '-3.9px',paddingLeft: '5.2px' }}>
                <Grid.Column style={{ width: '25%' }}>

                  <div id="chart" style={{ border: '1px solid #111111', borderRadius: '10px', backgroundColor: 'white' }}>
                    <h2 style={{ color: '#3B5999', margin: '0', textAlign: 'center', fontFamily: 'Poppins',fontWeight:'200' }}>Account Closure Status</h2>
                    <ReactApexChart options={chartDatanew1.options} series={chartDatanew1.series} onClick={getclosestatus} type="donut" height={225} />
                  </div>
              </Grid.Column>
                <Grid.Column style={{ width: '25%' }}>
                  <div id="chart" style={{ border: '1px solid #111111', borderRadius: '10px', backgroundColor: 'white' }}>
                    <h2 style={{ color: '#3B5999', margin: '0', textAlign: 'center', fontFamily: 'Poppins',fontWeight:'200' }}>Match Status</h2>
                    <ReactApexChart options={chartDatanew.options} series={chartDatanew.series} type="pie" height={225} />
                  </div>
              </Grid.Column>
              <Grid.Column style={{ width: '49%', backgroundColor: 'white',borderRadius : '10px', border: '1px solid #111111' }}>
              <h2 style={{ color: '#3B5999', margin: '0', textAlign: 'center', fontFamily: 'Poppins',fontWeight:'200' }}>Top 10 - TDS Deposited</h2>
                <BarGraph query={bankquery} data={data2} headers ={tandeductors} seriesLabel="ERP"/>
              </Grid.Column>
             </Grid.Row>

            <Grid.Row style={{ paddingTop: '0.5em', marginLeft: '-3.9px',paddingLeft: '5.2px' }}>
             <Grid.Column style={{ width: '49%', backgroundColor: 'white',borderRadius : '10px', border: '1px solid #111111',marginRight:"10px" }}>
              <h2 style={{ color: '#3B5999', margin: '0', textAlign: 'center', fontFamily: 'Poppins',fontWeight:'200' }}>Top 10 - TDS to be collected</h2>
                <BarGraph query={erpquery} data={data1} headers ={erptandeductors} seriesLabel="ERP"/>
              </Grid.Column>
            <Grid.Column style={{ width: '49.55%', backgroundColor: 'white',borderRadius : '10px', border: '1px solid #111111' }}>
              <h2 style={{ color: '#3B5999', margin: '0', textAlign: 'center', fontFamily: 'Poppins',fontWeight:'200' }}>Difference - Collected vs To be collected</h2>
                <DualBarGraph query1={differencequery} query2={differencequery} headers ={tanDifferenceheaders} data1={erpDifference} data2={bankDifference}   bar1Color="rgba(0, 128, 0, 1)" bar2Color="rgba(54, 162, 235, 1)"/>
              </Grid.Column>
            </Grid.Row>
          </Grid.Column>
        </Grid.Row>
      </Grid>


      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='col-md-11'>

            </div>
            <div className='col-md-1'>
              <a onClick={exportToExcel}>
                <FontAwesomeIcon icon={faFileExcel} style={{ fontSize: '30px', color: 'green' }} />
              </a>
            </div></div>
          <div className="ag-theme-alpine"
            style={{ height: '400px', width: '100%' }}
          >
            <AgGridReact
              columnDefs={modelcolumnnames}
              rowData={extGridData}
              animateRows={true}
              pagination={true}
              paginationPageSize={10}
            />
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DashboardComponent;